import { Pipe, PipeTransform } from '@angular/core';
import { Service } from '../models/service.model';
import { Stub } from '../models/stub.model';

@Pipe({
  name: 'NameFilter'
})
export class NameFilterPipe implements PipeTransform {

  transform(value: any[], filterBy: string, backendArray:any[]): any[] {
    filterBy = filterBy ? filterBy.toLocaleLowerCase() : null;
    if(!backendArray){
      return value;
    }
    return filterBy ? backendArray.filter((obj: any) => {
      if (obj.stubName) {//stub
        return obj.stubName.toLocaleLowerCase().indexOf(filterBy) !== -1;
      }
      else {//service
        return obj._id.toLocaleLowerCase().indexOf(filterBy) !== -1 || obj.urlMethod.toLocaleLowerCase().indexOf(filterBy) !== -1 ;
      }
    }) : value;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/name-filter.pipe.ts